import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";

const CONVERSATIONS = [
    {
        label: "2 AM craving",
        messages: [
            {
                from: "user",
                text: "It's 2 AM and I can't stop thinking about using.",
            },
            {
                from: "hope",
                text: "Cravings can spike when the world gets quiet. I'm here — want to talk it through before you do anything?",
            },
            {
                from: "user",
                text: "Yeah. I just need someone who won't judge me.",
            },
        ],
    },
    {
        label: "Morning check-in",
        messages: [
            {
                from: "hope",
                text: "Hey — how are you feeling this morning? I'm here to listen, not to judge.",
            },
            {
                from: "user",
                text: "Anxious but I didn't use. One day at a time.",
            },
            {
                from: "hope",
                text: "That takes courage. Want to do a 60-second check-in?",
            },
        ],
    },
    {
        label: "Milestone",
        messages: [
            {
                from: "user",
                text: "90 days today. I didn't think I'd get here.",
            },
            {
                from: "hope",
                text: "Ninety days is real work — not luck. How do you want to mark it?",
            },
            {
                from: "user",
                text: "Honestly? By not making it weird. Just acknowledging it.",
            },
        ],
    },
];

export default function HopeChatPreview() {
    const [active, setActive] = useState(0);

    useEffect(() => {
        const timer = window.setInterval(() => {
            setActive((current) => (current + 1) % CONVERSATIONS.length);
        }, 4000);
        return () => window.clearInterval(timer);
    }, []);

    const conversation = CONVERSATIONS[active];

    return (
        <div
            className="reveal flex justify-center lg:justify-end"
            data-testid="hero-phone-mockup"
            aria-label="Hope chat preview"
        >
            <div className="relative w-[min(100%,20rem)] sm:w-[24rem] lg:w-[min(100%,28rem)]">
                <div className="absolute -inset-8 rounded-full bg-gradient-to-tr from-emerald-500/30 via-cyan-500/15 to-violet-500/25 blur-3xl" />
                <div className="relative rounded-[2.6rem] border border-white/15 bg-gradient-to-b from-white/12 to-white/5 p-3 shadow-[0_50px_120px_rgba(6,9,25,0.6)]">
                    <div className="rounded-[2rem] overflow-hidden bg-[#0a1024] border border-white/6">
                        <div className="flex h-7 items-center justify-center">
                            <span className="h-1 w-10 rounded-full bg-white/20" />
                        </div>
                        <div className="px-4 pb-2 border-b border-white/8 flex items-center justify-between bg-[#0c1228]">
                            <div className="text-[11px] font-bold tracking-wide text-white/50 uppercase">
                                &nbsp;
                            </div>
                            <div className="flex items-center gap-1.5 text-emerald-300">
                                <MessageCircle className="w-4 h-4" />
                                <span className="text-sm font-semibold">Hope</span>
                            </div>
                            <div className="w-7" />
                        </div>
                        <div className="px-2 pt-2 pb-1 flex justify-center gap-2">
                            {/* {CONVERSATIONS.map((item, index) => (
                                <button
                                    key={item.label}
                                    type="button"
                                    onClick={() => setActive(index)}
                                    data-testid={`hope-preview-tab-${index}`}
                                    className={`rounded-full px-3 py-1 text-[10px] font-semibold transition-colors ${
                                        index === active
                                            ? "bg-emerald-500/20 text-emerald-200 border border-emerald-500/30"
                                            : "text-white/40 hover:text-white/70"
                                    }`}
                                >
                                    {item.label}
                                </button>
                            ))} */}
                        </div>
                        <div
                            key={active}
                            className="p-4 space-y-3 min-h-[17rem] sm:min-h-[19rem] bg-gradient-to-b from-[#0c1228] to-[#080d1c] animate-in fade-in duration-500"
                        >
                            <div className="text-[10px] text-center text-white/30 py-0.5">Today</div>
                            {conversation.messages.map((message, index) => (
                                <div
                                    key={`${active}-${index}`}
                                    className={`flex ${message.from === "user" ? "justify-end" : "justify-start"}`}
                                >
                                    <div
                                        className={`max-w-[88%] rounded-2xl px-3.5 py-2.5 text-[12px] sm:text-[13px] leading-relaxed ${
                                            message.from === "user"
                                                ? "rounded-tr-sm bg-emerald-500/20 border border-emerald-500/30 text-emerald-50/95"
                                                : "rounded-tl-sm bg-white/8 border border-white/8 text-white"
                                        }`}
                                    >
                                        {message.text}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="h-1.5 w-28 mx-auto my-2.5 rounded-full bg-white/10" />
                    </div>
                </div>
            </div>
        </div>
    );
}
